import React from "react";

function Footer() {
  return (
    <footer className="footer  bg5-color">
      <div className="container-fluid">
        <div className="row align-items-center justify-content-center py-3 py-sm-4 py-lg-6 bg2-color">
          <div className="col-sm-10 col-xxl-6 d-flex justify-content-center">
            <div className="footer__copyright text-center d-flex align-items-center justify-content-center justify-content-md-between flex-wrap flex-md-nowrap">
              <div className="copy-right area">
                <span className="p4-color roboto text-center text-md-start">
                  Copyright 2024 &nbsp;
                  <a href="/" className="p9-color">
                    Aarma
                  </a>
                  &nbsp; All Rights Reserved
                </span>
              </div>
            </div>
          </div>
          <div className="col-lg-6 d-flex justify-content-center">
            <div className="contact_info__card-social d-flex align-items-center justify-content-start gap-2 gap-md-3 wow fadeInUp">
              <a href="javascript:void(0)">
                <i className="fa fa-facebook p4-color fs-four fw-normal px-4 py-2" />
              </a>
              <a href="javascript:void(0)">
                <i className="fa fa-linkedin p4-color fs-four fw-normal px-3 py-2" />
              </a>
              <a href="javascript:void(0)">
                <i className="fa fa-instagram p4-color fs-four fw-normal px-3 py-2" />
              </a>
              <a href="javascript:void(0)">
                <i className="fa fa-twitter p4-color fs-four fw-normal px-3 py-2" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
